// 机型管理相关API服务
import { httpClient } from '../http';
import {
  DeviceModel,
  CreateDeviceModelRequest,
  UpdateDeviceModelRequest,
  DeviceModelOption,
  PaginationParams,
  PaginationResponse,
} from '@/types/api';

export class DeviceModelsAPI {
  // 获取机型列表
  async getDeviceModels(params?: PaginationParams & { status?: string; chip_vendor?: string }): Promise<PaginationResponse<DeviceModel>> {
    const response = await httpClient.get<PaginationResponse<DeviceModel>>('/admin/device-models', params);
    return response.data;
  }

  // 获取机型详情
  async getDeviceModelById(id: number): Promise<DeviceModel> {
    const response = await httpClient.get<DeviceModel>(`/admin/device-models/${id}`);
    return response.data;
  }

  // 创建机型
  async createDeviceModel(modelData: CreateDeviceModelRequest): Promise<DeviceModel> {
    const response = await httpClient.post<DeviceModel>('/admin/device-models', modelData);
    return response.data;
  }

  // 更新机型
  async updateDeviceModel(id: number, modelData: UpdateDeviceModelRequest): Promise<DeviceModel> {
    const response = await httpClient.put<DeviceModel>(`/admin/device-models/${id}`, modelData);
    return response.data;
  }

  // 删除机型
  async deleteDeviceModel(id: number): Promise<void> {
    await httpClient.delete(`/admin/device-models/${id}`);
  }

  // 获取机型选项列表（用于下拉选择）
  async getDeviceModelOptions(): Promise<DeviceModelOption[]> {
    const response = await httpClient.get<DeviceModelOption[]>('/admin/device-model-options');
    return response.data || [];
  }

  // 获取芯片厂商列表
  async getChipVendors(): Promise<string[]> {
    const response = await httpClient.get<string[]>('/admin/chip-vendors');
    return response.data || [];
  }

  // 获取操作系统列表
  async getOperatingSystems(): Promise<string[]> {
    const response = await httpClient.get<string[]>('/admin/operating-systems');
    return response.data || [];
  }

  // 获取机型状态列表
  async getDeviceModelStatuses(): Promise<Array<{ value: string; label: string }>> {
    const response = await httpClient.get<Array<{ value: string; label: string }>>('/admin/device-model-statuses');
    return response.data || [];
  }
}

// 导出单例实例
export const deviceModelsAPI = new DeviceModelsAPI();
